
export const checkHexColor = (c: string) => c && /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(c);